import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("Auswahl bestätigen")
const _hoisted_2 = /*#__PURE__*/_createVNode("p", null, "Bitte bestätigen Sie die Auswahl.", -1)
const _hoisted_3 = { class: "ion-margin ion-padding" }
const _hoisted_4 = /*#__PURE__*/_createVNode("b", null, "Juror: ", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("b", null, "Tisch: ", -1)
const _hoisted_6 = /*#__PURE__*/_createTextVNode("Angaben bestätigen")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Käse Liste")
const _hoisted_8 = /*#__PURE__*/_createVNode("p", null, "Wählen Sie einen Käse aus oder scannen Sie den QR Code.", -1)
const _hoisted_9 = /*#__PURE__*/_createTextVNode("QR Code Scannen ")
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "card-pre-header success" }, null, -1)
const _hoisted_12 = { class: "ion-padding ion-margin-top" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Käse bewertet")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Tisch abschließen ")
const _hoisted_17 = { key: 0 }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "card-pre-header success" }, null, -1)
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "card-pre-header warning" }, null, -1)
const _hoisted_21 = { key: 2 }
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "card-pre-header danger " }, null, -1)
const _hoisted_23 = { key: 0 }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", null, "Bewertung abgeschlossen", -1)
const _hoisted_25 = { key: 1 }
const _hoisted_26 = /*#__PURE__*/_createVNode("p", null, "Bewertung noch nicht abgeschlossen", -1)
const _hoisted_27 = { key: 2 }
const _hoisted_28 = /*#__PURE__*/_createVNode("p", null, "Bewertung offen", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")
  const _component_ion_card_title = _resolveComponent("ion-card-title")
  const _component_ion_card_header = _resolveComponent("ion-card-header")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_card_content = _resolveComponent("ion-card-content")
  const _component_ion_card = _resolveComponent("ion-card")
  const _component_IonCol = _resolveComponent("IonCol")
  const _component_IonRow = _resolveComponent("IonRow")
  const _component_IonGrid = _resolveComponent("IonGrid")
  const _component_ionIcon = _resolveComponent("ionIcon")
  const _component_IonContent = _resolveComponent("IonContent")
  const _component_IonPage = _resolveComponent("IonPage")

  return (_openBlock(), _createBlock(_component_IonPage, null, {
    default: _withCtx(() => [
      _createVNode(_component_Header, {
        title: _ctx.getJurorName,
        back: true
      }, null, 8, ["title"]),
      _createVNode(_component_IonContent, { fullscreen: "" }, {
        default: _withCtx(() => [
          (!_ctx.accepted)
            ? (_openBlock(), _createBlock(_component_IonGrid, { key: 0 }, {
                default: _withCtx(() => [
                  _createVNode(_component_IonRow, { class: "ion-justify-content-center ion-align-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IonCol, {
                        class: "ion-text-center ion-margin-top ion-padding-top ",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card, { color: "light" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_header, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_title, null, {
                                    default: _withCtx(() => [
                                      _hoisted_1
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_content, null, {
                                default: _withCtx(() => [
                                  _hoisted_2,
                                  _createVNode("div", _hoisted_3, [
                                    _createVNode("p", null, [
                                      _hoisted_4,
                                      _createTextVNode(_toDisplayString(_ctx.getLoggedInJuror), 1)
                                    ]),
                                    _createVNode("p", null, [
                                      _hoisted_5,
                                      _createTextVNode(" " + _toDisplayString(_ctx.getCurrentTable), 1)
                                    ])
                                  ]),
                                  _createVNode(_component_ion_button, {
                                    expand: "block",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.accepted = true))
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_6
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_ctx.accepted)
            ? (_openBlock(), _createBlock(_component_IonGrid, { key: 1 }, {
                default: _withCtx(() => [
                  _createVNode(_component_IonRow, { class: "ion-justify-content-center ion-align-items-center" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_IonCol, { class: "ion-text-center ion-margin-top ion-padding-top " }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card, { color: "light" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_card_header, { class: "ion-padding" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_card_title, null, {
                                    default: _withCtx(() => [
                                      _hoisted_7
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_ion_card_content, null, {
                                default: _withCtx(() => [
                                  _hoisted_8,
                                  _createVNode(_component_ion_button, {
                                    class: "ion-margin",
                                    expand: "block",
                                    onClick: _ctx.openQRModal
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_9
                                    ]),
                                    _: 1
                                  }, 8, ["onClick"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_IonCol, {
                        class: "ion-text-center ion-margin-top ion-padding-top",
                        size: "12"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_card, { color: "light" }, {
                            default: _withCtx(() => [
                              (_ctx.getCountDonePlates === _ctx.getCheeseList.length)
                                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                                    _hoisted_11
                                  ]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_ion_card_content, null, {
                                default: _withCtx(() => [
                                  _createVNode("div", _hoisted_12, [
                                    (_ctx.getCountDonePlates !== _ctx.getCheeseList.length)
                                      ? (_openBlock(), _createBlock("p", _hoisted_13, "Sie haben noch nicht alle Käse dieses Tisches bewertet."))
                                      : (_openBlock(), _createBlock("p", _hoisted_14, "Sie haben alle Käse dieses Tisches bewertet. Sie können den Tisch nun abschließen."))
                                  ]),
                                  (_ctx.getCountDonePlates !== _ctx.getCheeseList.length)
                                    ? (_openBlock(), _createBlock(_component_ionIcon, {
                                        key: 0,
                                        icon: _ctx.closeCircleOutline ,
                                        class: "big-icon"
                                      }, null, 8, ["icon"]))
                                    : (_openBlock(), _createBlock(_component_ionIcon, {
                                        key: 1,
                                        icon: _ctx.checkmarkCircleOutline,
                                        class: "big-icon success"
                                      }, null, 8, ["icon"])),
                                  _createVNode("p", null, [
                                    _createVNode("strong", null, _toDisplayString(_ctx.getCountDonePlates) + "/" + _toDisplayString(_ctx.getCheeseList.length), 1),
                                    _hoisted_15
                                  ]),
                                  _createVNode(_component_ion_button, {
                                    onClick: _ctx.lockTable,
                                    class: "ion-margin",
                                    color: "success",
                                    disabled: _ctx.getCountDonePlates !== _ctx.getCheeseList.length,
                                    expand: "block"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_16
                                    ]),
                                    _: 1
                                  }, 8, ["onClick", "disabled"])
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_IonRow, { class: "ion-justify-content-center ion-align-items-center" }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.getCheeseList, (plate) => {
                        return (_openBlock(), _createBlock(_component_IonCol, {
                          key: plate.id,
                          class: "ion-text-center",
                          size: "12"
                        }, {
                          default: _withCtx(() => [
                            _createVNode("div", {
                              onClick: ($event: any) => (_ctx.openRating(plate.cheese.id, plate.cheese.innovation))
                            }, [
                              _createVNode(_component_ion_card, { color: "light" }, {
                                default: _withCtx(() => [
                                  (_ctx.getResultState(plate) === 'finished')
                                    ? (_openBlock(), _createBlock("div", _hoisted_17, [
                                        _hoisted_18
                                      ]))
                                    : (_ctx.getResultState(plate) === 'active')
                                      ? (_openBlock(), _createBlock("div", _hoisted_19, [
                                          _hoisted_20
                                        ]))
                                      : (_openBlock(), _createBlock("div", _hoisted_21, [
                                          _hoisted_22
                                        ])),
                                  _createVNode(_component_ion_card_header, null, {
                                    default: _withCtx(() => [
                                      _createVNode("h6", null, _toDisplayString(plate.coding), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createVNode(_component_ion_card_content, null, {
                                    default: _withCtx(() => [
                                      (_ctx.getResultState(plate) === 'finished')
                                        ? (_openBlock(), _createBlock("div", _hoisted_23, [
                                            _createVNode(_component_ionIcon, {
                                              icon: _ctx.checkmarkCircleOutline,
                                              class: "big-icon success"
                                            }, null, 8, ["icon"]),
                                            _hoisted_24
                                          ]))
                                        : (_ctx.getResultState(plate) === 'active')
                                          ? (_openBlock(), _createBlock("div", _hoisted_25, [
                                              _createVNode(_component_ionIcon, {
                                                icon: _ctx.helpCircleOutline ,
                                                class: "big-icon"
                                              }, null, 8, ["icon"]),
                                              _hoisted_26
                                            ]))
                                          : (_openBlock(), _createBlock("div", _hoisted_27, [
                                              _createVNode(_component_ionIcon, {
                                                icon: _ctx.closeCircleOutline ,
                                                class: "big-icon"
                                              }, null, 8, ["icon"]),
                                              _hoisted_28
                                            ]))
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024)
                            ], 8, ["onClick"])
                          ]),
                          _: 2
                        }, 1024))
                      }), 128))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}